import { nonEmptyString } from '@atlassian/amkt-common';
import { makeAppKey } from '@atlassian/mpac-api-client';
import { Option } from 'funfix-core';
import { Record } from 'immutable';
import { makeRelayState } from '../types/RelayState';
import { makeInstallableAppByKeyIdentifier, makeInstallableAppByUrlIdentifier } from './InstallableAppIdentifier';
const DISCOVER_TARGET = 'DISCOVER';
const MANAGE_TARGET = 'MANAGE';
const INSTALL_TARGET = 'INSTALL';
const TOKEN_TARGET = 'TOKEN';
export const makeDiscoverTarget = Record({
  type: DISCOVER_TARGET
});
export const makeManageTarget = Record({
  type: MANAGE_TARGET
});
export const makeInstallTarget = Record({
  type: INSTALL_TARGET,
  installableAppId: makeInstallableAppByKeyIdentifier()
});
export const makeTokenTarget = Record({
  type: TOKEN_TARGET,
  tokenName: null
});
export function foldTarget(target) {
  return function foldTargetInner(discover, manage, install, token) {
    switch (target.type) {
      case DISCOVER_TARGET:
        return discover(target);
      case MANAGE_TARGET:
        return manage(target);
      case INSTALL_TARGET:
        return install(target);
      case TOKEN_TARGET:
        return token(target);
      default:
        // Flow compile-time validation that we've handled every discover item
        // prettier-ignore
        target;
        return undefined;
    }
  };
}
export const makeReceivedParameters = Record({
  target: Option.none(),
  relayState: undefined
});
const resolveTargetFromRaw = rawReceivedParameters => Option.of(rawReceivedParameters.target).map(rawTarget => rawTarget.toLowerCase().trim()).flatMap(rawTarget => {
  switch (rawTarget) {
    case 'discover':
      return Option.some(makeDiscoverTarget());
    case 'manage':
      return Option.some(makeManageTarget());
    case 'install':
      return (nonEmptyString(rawReceivedParameters.app_url) ? Option.of(makeInstallableAppByUrlIdentifier({
        url: nonEmptyString(rawReceivedParameters.app_url)
      })) : Option.of(rawReceivedParameters.key).map(key => makeInstallableAppByKeyIdentifier({
        key: makeAppKey(key)
      }))).map(installableAppId => makeInstallTarget({
        installableAppId
      }));
    case 'token':
      return Option.some(makeTokenTarget({
        tokenName: nonEmptyString(rawReceivedParameters.tokenName)
      }));
    default:
      return Option.none();
  }
});
export const makeReceivedParametersFromRaw = rawReceivedParameters => makeReceivedParameters({
  relayState: rawReceivedParameters.relayState ? makeRelayState(rawReceivedParameters.relayState) : undefined,
  target: resolveTargetFromRaw(rawReceivedParameters)
});